import React from 'react';
import { Select } from 'antd';
export interface LoginYnSelectBox {
  userLoginYn: string|undefined;
  onUserLoginYn: (value: string) => void;
}

const LoginYn = ({
  userLoginYn,
  onUserLoginYn
}: LoginYnSelectBox): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Select
      style={{width:"100px"}} 
      value={userLoginYn}
      placeholder="사용여부"
      onSelect={onUserLoginYn}
      options={[
        {
          value: 'A',
          label: '전체',
        },
        {
          value: 'Y',
          label: '사용',
        },
        {
          value: 'N',
          label: '미사용',
        },          
      ]}
    /> 
  );
};

export default LoginYn;
